module.exports = __webpack_public_path__ + "media/images/edion/popular/1-d6aea64f48cb990c7bf285a84446e048.png";